import type { CreateClientConfig } from '../../client/client.gen';

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  // credentials: 'include',
  // TODO: comment this in and remove setup-auth.ts when we are ready to migrate to WorkOS.
});
